import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

import {
  TransactionDetailsQueryEnum,
  TransactionFilterEnum
} from '@models/entities/transactions'
import { type TransactionType } from '@models/entities/transactions'

import { queryController } from '@composables/queryController'

export const useTransactionsQueryStore = defineStore('useTransactionsQueryStore', () => {
  const route = useRoute()
  const { getQueryString } = queryController()

  const getInitialState = () => ({
    [TransactionFilterEnum.search]: getQueryString(route.query, TransactionFilterEnum.search),
    [TransactionFilterEnum.type]: getQueryString(route.query, TransactionFilterEnum.type),
    [TransactionFilterEnum.point]: getQueryString(route.query, TransactionFilterEnum.point),
    [TransactionFilterEnum.currency]: getQueryString(route.query, TransactionFilterEnum.currency),
    [TransactionFilterEnum.method]: getQueryString(route.query, TransactionFilterEnum.method),
    [TransactionFilterEnum.status]: getQueryString(route.query, TransactionFilterEnum.status),
    [TransactionFilterEnum.amount_from]: getQueryString(route.query, TransactionFilterEnum.amount_from),
    [TransactionFilterEnum.amount_to]: getQueryString(route.query, TransactionFilterEnum.amount_to),
    [TransactionFilterEnum.updated_date_from]: getQueryString(route.query, TransactionFilterEnum.updated_date_from),
    [TransactionFilterEnum.updated_date_to]: getQueryString(route.query, TransactionFilterEnum.updated_date_to),
    [TransactionFilterEnum.user_id_search]: getQueryString(route.query, TransactionFilterEnum.user_id_search)
  })

  const getDetailsState = () => ({
    [TransactionDetailsQueryEnum.transaction_id]: getQueryString(route.query, TransactionDetailsQueryEnum.transaction_id)
  })

  const state = ref(getInitialState())
  const detailsState = ref(getDetailsState())

  const setSelectedTransactionQuery = (transaction: TransactionType | null) => {
    detailsState.value[TransactionDetailsQueryEnum.transaction_id] = transaction?.id ?? ''
  }

  const setSearchQuery = (val: string) => {
    state.value[TransactionFilterEnum.search] = val
  }

  const updateStateQuery = (vals: Partial<Record<TransactionFilterEnum, string>>, clearSearch = false) => {
    if (clearSearch) {
      vals[TransactionFilterEnum.search] = ''
    }
    state.value = { ...state.value, ...vals }
  }

  const clearState = () => {
    state.value = {
      [TransactionFilterEnum.search]: '',
      [TransactionFilterEnum.type]: '',
      [TransactionFilterEnum.point]: '',
      [TransactionFilterEnum.currency]: '',
      [TransactionFilterEnum.method]: '',
      [TransactionFilterEnum.status]: '',
      [TransactionFilterEnum.amount_from]: '',
      [TransactionFilterEnum.amount_to]: '',
      [TransactionFilterEnum.updated_date_from]: '',
      [TransactionFilterEnum.updated_date_to]: '',
      [TransactionFilterEnum.user_id_search]: ''
    }
  }

  const clearStateDetails = () => {
    detailsState.value = { transaction_id: '' }
  }

  const clearStateByKeys = (keyList: TransactionFilterEnum[]) => {
    keyList.forEach(key => {
      state.value[key] = ''
    })
  }

  return {
    state,
    detailsState,
    setSelectedTransactionQuery,
    setSearchQuery,
    updateStateQuery,
    clearState,
    clearStateDetails,
    clearStateByKeys
  }
})
